var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 15,
    fill: "#F11A7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4302 21.0603C38.446 21.2823 38.446 21.5044 38.446 21.7265C38.446 28.5 33.2906 36.3045 23.868 36.3045C20.9651 36.3045 18.2684 35.4638 16 34.0044C16.4125 34.052 16.809 34.0679 17.2373 34.0679C19.6326 34.0679 21.8375 33.2589 23.5983 31.8788C21.3458 31.8312 19.4581 30.356 18.8077 28.3255C19.125 28.373 19.4422 28.4048 19.7754 28.4048C20.2354 28.4048 20.6955 28.3413 21.1237 28.2303C18.776 27.7544 17.0152 25.6922 17.0152 23.2018V23.1383C17.6973 23.519 18.4905 23.757 19.3312 23.7887C17.9511 22.8686 17.0469 21.2982 17.0469 19.5215C17.0469 18.5698 17.3007 17.6973 17.7449 16.9359C20.2671 20.045 24.0583 22.0754 28.3096 22.2976C28.2303 21.9168 28.1827 21.5203 28.1827 21.1237C28.1827 18.3001 30.4669 16 33.3064 16C34.7816 16 36.1141 16.6187 37.05 17.618C38.208 17.3959 39.3184 16.9676 40.302 16.3807C39.9212 17.5705 39.1122 18.5698 38.0494 19.2043C39.0805 19.0933 40.0799 18.8077 40.9999 18.4112C40.302 19.4264 39.4295 20.3305 38.4302 21.0603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a2b05fbc0ac8a79fc27b494d8d274cc6.svg";
export { ForwardRef as ReactComponent };